import { AvatarComponentModule } from './../../_component/avatar/avatar.module';
import { ApiNotFoundComponentModule } from './../../_component/api-not-found/api-not-found.component.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { PaginationClientSideModule } from "src/app/app/_component/pagination-client-side/pagination-client-side.module";
import { SelectButtonsModule } from "src/app/app/_component/select-buttons/select-buttons.module";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { StatusModule } from "src/app/app/_component/status/status.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { PipesModule } from "src/app/_pipes/pipes.module";
import { OrderDetailsViewModule } from "../order-details-view/order-details-view.module";
import { BreadcrumbComponentModule } from './../../_component/breadcrumb/breadcrumb.module';
import { OrderDetailsPageRoutingModule } from "./order-details-routing.module";
import { OrderDetailsPage } from "./order-details.page";




@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    OrderDetailsPageRoutingModule,
    TranslateModule,
    PaginationClientSideModule,
    OrderDetailsViewModule,
    HeaderModule,
    SharedDirectivesModule,
    SelectDropdownModule,
    ReactiveFormsModule,
    SelectButtonsModule,
    StatusModule,
    LoadingStiModule,
    PipesModule,
    BreadcrumbComponentModule,
    ApiNotFoundComponentModule,
    AvatarComponentModule
  ],
  declarations: [OrderDetailsPage],
})
export class OrderDetailsPageModule {}
